import { render, staticRenderFns } from "./AddQuestionCategoryForm.vue?vue&type=template&id=f7ac0a80&scoped=true"
import script from "./AddQuestionCategoryForm.vue?vue&type=script&lang=js"
export * from "./AddQuestionCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ac0a80",
  null
  
)

export default component.exports